import { Component, input, signal } from '@angular/core';
import { Content, ContentScoringMethod } from '@mira-avant/mtlibs';
import { TakeResponse, TakeService } from '../../../../../services/take.service';
import { ActivatedRoute } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { CommonModule } from '@angular/common';

@Component({
	selector: 'app-rich-text-player',
	standalone: true,
	imports: [CommonModule, NzSpinModule],
	templateUrl: './rich-text-player.component.html',
	styleUrl: './rich-text-player.component.scss',
})
export class RichTextPlayerComponent {
	content = input<Content | undefined>();
	loading = signal<boolean>(true);
	takeNumber = signal<number | undefined>(undefined);
	newTake = signal<TakeResponse | undefined>(undefined);
	dontTrackTake = input<boolean>(false);

	constructor(
		public route: ActivatedRoute,
		public takeService: TakeService,
		private zorroMessenger: NzMessageService
	) {}

	async ngOnInit(): Promise<void> {
		const content = this.content();

		if (!content) {
			throw new Error('Missing content');
		}

		if (this.dontTrackTake()) {
			this.loading.set(false);
			return;
		}

		await this.takeService
			.createTake$({
				course_uuid: this.route.snapshot.params['courseUuid'],
				location_uuid: this.route.snapshot.params['locationUuid'],
				section_uuid: this.route.snapshot.params['sectionUuid'],
				unit_uuid: this.route.snapshot.params['unitUuid'],
				lesson_uuid: this.route.snapshot.params['lessonUuid'],
				activity_uuid: this.route.snapshot.params['activityUuid'],
				content_uuid: content.uuid,
				scoring_method: content.scoring_method as ContentScoringMethod,
			})
			.then(async takeResponse => {
				if (!content) {
					throw new Error('Missing content');
				}

				this.takeNumber.set(takeResponse.take.take);
				this.newTake.set(takeResponse);

				if ([ContentScoringMethod.VIEWED].includes(content.scoring_method as ContentScoringMethod)) {
					await this.takeService.completeTake$({
						course_uuid: this.route.snapshot.params['courseUuid'],
						location_uuid: this.route.snapshot.params['locationUuid'],
						section_uuid: this.route.snapshot.params['sectionUuid'],
						unit_uuid: this.route.snapshot.params['unitUuid'],
						lesson_uuid: this.route.snapshot.params['lessonUuid'],
						activity_uuid: this.route.snapshot.params['activityUuid'],
						content_uuid: content.uuid,
						take: this.newTake()!.take.take,
						duration: 0,
					});
				} else {
					console.warn('Skipping reporting & XAPI events as this content is not scored.');
				}

				return takeResponse;
			})
			.catch(error => {
				this.zorroMessenger.error('Unable to begin activity. Please try again later.');
			})
			.finally(() => {
				this.loading.set(false);
			});
	}
}
